import React, { useState, useEffect, useCallback } from "react";
import { auth } from "../Services/firebaseAuth";
import { onAuthStateChanged, sendEmailVerification } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../Components/Footer";

const VerifyEmail = () => {
	const { t } = useTranslation();
	window.scrollTo(0, 0);
	const navigate = useNavigate();
	const navigateTo = useCallback(
		(path) => {
			if (path) {
				navigate(path);
			}
		},
		[navigate]
	);

	const [verifyState, setVerifyState] = useState("pending");
	const [count, setCount] = useState(10);
	const [redirect, setRedirect] = useState(false);

	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, async (user) => {
			if (user) {
				try {
					await user.reload(); // Checking email verification status
					if (user.emailVerified) {
						setVerifyState("success");
						setTimeout(() => {
							navigate("/login");
						}, 5000);
					} else {
						setVerifyState("failed");
						setTimeout(() => {
							setRedirect(true);
						}, 10000);
					}
				} catch (err) {
					console.error("Error reloading user:", err);
					setVerifyState("error");
				}
			} else {
				setVerifyState("notLoggedIn");
				setTimeout(() => {
					setRedirect(true);
				}, 10000);
			}
		});

		return () => unsubscribe();
	}, []);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (count > 0) {
				setCount(count - 1);
			} else {
				setRedirect(true);
				// window.location.href = '/';
			}
		}, 1000);
		return () => clearTimeout(timer);
	}, [count]);

	return (
		<section>
			<div className="relative flex min-h-screen flex-col justify-center overflow-hidden bg-gray-50 py-12">
				<div className="relative bg-white px-6 pt-10 pb-9 shadow-xl mx-auto w-full max-w-lg rounded-2xl">
					{verifyState === "pending" ? (
						<div>
							<div className="mt-20 mb-20 py-30 text-center">
								<h1 className="text-5xl md:text-8xl lg:text-10xl text-center font-bold my-10 font-sans bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-transparent bg-clip-text">
									{t("youAreOnTheWay")}
								</h1>
								<h1 className="font-medium cursor-pointer text-slate-800 hover:text-slate-600">
									{t("email_being_verified")}
								</h1>
							</div>

							<div className="mt-20 mb-20 py-30 flex justify-center items-center">
								<div className="w-32 h-32 border-t-transparent border-solid animate-spin rounded-full border-slate-800 border-8"></div>
							</div>
						</div>
					) : verifyState === "success" ? (
						<div>
							<div className="mt-20 mb-20 py-30 text-center">
								<h1 className="text-5xl md:text-8xl lg:text-10xl text-center font-bold my-10 font-sans bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-transparent bg-clip-text">
									{t("success")}
								</h1>
								<h1 className="font-medium cursor-pointer text-slate-800 hover:text-slate-600">
									{t("email_verified")}
									{t("heidi_full_extend")}
								</h1>
							</div>

							<div className="mb-20 mt-20 py-30 text-center">
								<button
									type="submit"
									onClick={() => navigateTo("/login")}
									className={`bg-gradient-to-r font-md text-gray-300 from-gray-700 to-slate-600 shadow-lg p-2 text-white rounded-lg w-full hover:scale-105 hover:from-gray-700 hover:to-slate-600 transition duration-300 ease-in-out`}
								>
									{t("goback")}
								</button>
							</div>

							<div className="mb-20 mt-20 py-30 text-center">
								{redirect ? (
									<h1 className=" m-auto mt-20 text-center font-sans font-semibold text-lg">
										{t("please_wait")}
									</h1>
								) : (
									<h1 className=" m-auto mt-20 text-center font-sans font-semibold text-lg">
										{t("redirecting_in")} ( {count} ) {t("seconds")}
									</h1>
								)}
							</div>
						</div>
					) : verifyState === "notLoggedIn" ? (
						<div className="text-center mt-20 mb-20">
							<h1 className="text-2xl font-bold">{t("youAreNotLoggedIn")}</h1>
							<p className="font-medium cursor-pointer text-slate-800 hover:text-slate-600">{t("pleaseLoginToVerifyEmail")}</p>
							<button
								onClick={() => navigateTo("/login")}
								className={`bg-gradient-to-r font-md text-gray-300 from-gray-700 to-slate-600 shadow-lg p-2 text-white rounded-lg w-full hover:scale-105 hover:from-gray-700 hover:to-slate-600 transition duration-300 ease-in-out`}
							>
								{t("goToLogin")}
							</button>
						</div>
					) : (
						<div>
							<div className="mt-20 mb-20 py-30 text-center">
								<h1 className="text-5xl md:text-8xl lg:text-10xl text-center font-bold my-20 py-2 font-sans bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-transparent bg-clip-text">
									{t("Failed")}
								</h1>
								<h1 className="font-medium cursor-pointer text-slate-800 hover:text-slate-600">
									{t("email_verification_not_succesfull")}
								</h1>
							</div>

							<div className="mt-20 mb-20 py-30 text-center">
								<button
									type="submit"
									onClick={() => navigateTo("/login")}
									className={`bg-gradient-to-r font-md text-gray-300 from-gray-700 to-slate-600 shadow-lg p-2 text-white rounded-lg w-full hover:scale-105 hover:from-gray-700 hover:to-slate-600 transition duration-300 ease-in-out`}
								>
									{t("goback")}
								</button>
								<button
									onClick={async () => {
										const user = auth.currentUser;
										if (user && !user.emailVerified) {
											await sendEmailVerification(user);
											alert(t("verificationEmailSent"));
										}
									}}
									className="font-medium cursor-pointer text-slate-800 hover:text-slate-600 mt-4"
								>
									{t("resendEmailVerification")}
								</button>
							</div>
						</div>
					)}
				</div>
			</div>

			<div className="bottom-0 w-full">
				<Footer />
			</div>
		</section>
	);
};

export default VerifyEmail;
